/**
 * <ReferralShareActions> — social share icon row (molecule, L0.1).
 *
 * Actions are injected (icon + color + onPress). No brand hex — semantic tokens only.
 */
import { StyleSheet } from "react-native-unistyles"

import { IconButton } from "../../atoms/Buttons/IconButton"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { type IconName } from "../../atoms/icons/Icon"
import { type SemanticColorKey } from "../../theme/tokens/colors"

/** Un canal de partage : un `<IconButton>` rond de 44 px — exporté pour la place de son squelette. */
export const SHARE_ACTION_SIZE = 44

export type ReferralShareActionItem = {
    id: string
    iconName: IconName
    color: SemanticColorKey
    onPress: () => void
}

export type ReferralShareActionsProps = {
    actions: ReferralShareActionItem[]
    testID?: string
}

export function ReferralShareActions(props: ReferralShareActionsProps) {
    const { actions, testID } = props
    if (actions.length === 0) return null

    return (
        <Stack gap="2" align="center" testID={testID}>
            <Text size="text-sm" weight="semibold" color="text-muted" center>
                Partagez via
            </Text>
            <Row justify="center" gap="2" style={styles.row}>
                {actions.map((action) => (
                    <IconButton
                        key={action.id}
                        iconName={action.iconName}
                        color={action.color}
                        size={SHARE_ACTION_SIZE}
                        onPress={action.onPress}
                    />
                ))}
            </Row>
        </Stack>
    )
}

const styles = StyleSheet.create(() => ({
    row: {
        width: "100%",
    },
}))
